import { CustomerPartPrice, InventryLocation, PartInventory } from "@dana/Handlers/ProductAvailabilityHandler";
import ProductAvailabilityState from "@dana/Store/Data/ProductAvailability/ProductAvailabilityState";
import SelectedInventryLocationsState from "@dana/Store/Data/ProductAvailability/SelectedInventryLocationsState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: SelectedInventryLocationsState = {
    selectedLocations:[] as InventryLocation[],
     productId:"",
}

const selectedInventryLocationsImmerReducer = createTypedReducerWithImmer(initialState, {
    "SelectedInventryLocations/ResetLocations": (draft: Draft<SelectedInventryLocationsState>) => {
        draft = { ...initialState };
        return draft;
    },
    "SelectedInventryLocations/UpdateLocations": (draft: Draft<SelectedInventryLocationsState>, action: { selectedLocations?:InventryLocation[], productId:string }) => {

        draft = {
            productId:action.productId,
            selectedLocations: action.selectedLocations,
        };
        return draft;
    },
    
});

(reducers as any).selectedInventryLocationsState = selectedInventryLocationsImmerReducer;

type SelectedInventryLocationsReducers = {
    selectedInventryLocationsState: typeof selectedInventryLocationsImmerReducer;
};

export type SelectedInventryLocationsActions = Parameters<SelectedInventryLocationsReducers[keyof SelectedInventryLocationsReducers]>[1] | AnyAction;

